import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bottom-sheet__header" }

import { onMounted, ref } from 'vue'
import { SheetView } from '@/models/sheet'

/**
 * A modal anchored to the bottom of the screen.
 *
 * This component wraps the given content in a bottom sheet, that can be dismissed
 * by tapping outside of it, or by swiping it down. This component is only visible on
 * tablet and mobile screens.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'BottomSheet',
  props: {
    innerClass: {},
    fullscreen: { type: Boolean, default: false }
  },
  setup(__props: any, { expose: __expose }) {



const elementRef = ref<HTMLElement | null>(null)
const view = ref(new SheetView())

onMounted(() => {
  view.value.setSheetElement(elementRef)
})

__expose({
  view,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#appRoot" }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["bottom-sheet", {
          'bottom-sheet--fullscreen': __props.fullscreen,
        }])
        }, [
          _createElementVNode("div", {
            class: "bottom-sheet__background",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (view.value.close && view.value.close(...args)))
          }),
          _createVNode(_Transition, { name: "slide-vertical" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", {
                ref_key: "elementRef",
                ref: elementRef,
                class: _normalizeClass(["bottom-sheet__inner", __props.innerClass ? __props.innerClass : '']),
                style: _normalizeStyle(view.value.currentPositionCssVariable),
                onTouchstart: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (view.value.handleTouchStart && view.value.handleTouchStart(...args))),
                onTouchmove: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (view.value.handleTouchMove && view.value.handleTouchMove(...args))),
                onTouchend: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (view.value.handleTouchEnd && view.value.handleTouchEnd(...args))),
                onTouchcancel: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (view.value.handleTouchEnd && view.value.handleTouchEnd(...args)))
              }, [
                _createElementVNode("div", _hoisted_1, [
                  (__props.fullscreen)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "bottom-sheet__close",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (view.value.close && view.value.close(...args)))
                      }, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("span", { class: "iconfont iclose-thin" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ]),
                _renderSlot(_ctx.$slots, "default")
              ], 38), [
                [_vShow, view.value.isOpen]
              ])
            ]),
            _: 3
          })
        ], 2), [
          [_vShow, view.value.isOpen]
        ])
      ]),
      _: 3
    })
  ]))
}
}

})